// Master v5 Prompt 31 — shared local date/time helpers for the two
// coach composers that pick a candidate Session time (TimeProposalComposer,
// CompleteSessionWizard's "propose next session"). Deliberately NEVER a
// combined native <input type="datetime-local"> — a locale where the
// widget's AM/PM segment isn't fully committed leaves `.value` as an
// empty string even though it visually shows a value (reproduced with a
// Greek-locale browser), which silently dropped valid-looking candidate
// times. Separate date + 24h hour/minute selects have no such segment.
export const HOURS = Array.from({ length: 24 }, (_, h) => String(h).padStart(2, "0"));
export const MINUTES = ["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"];
export const BROWSER_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

export function todayLocalISODate() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function nowLocalHourMinute() {
  const d = new Date();
  const roundedMinute = MINUTES[Math.floor(d.getMinutes() / 5)];
  return { hour: String(d.getHours()).padStart(2, "0"), minute: roundedMinute };
}

// slot = { date: "YYYY-MM-DD", hour: "HH", minute: "MM" } -> Date | null
export function toLocalDate(slot) {
  if (!slot?.date || !slot?.hour || !slot?.minute) return null;
  const d = new Date(`${slot.date}T${slot.hour}:${slot.minute}:00`);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatInTimezone(date, timeZone) {
  return new Intl.DateTimeFormat("en-US", {
    weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", timeZone,
  }).format(date);
}
